import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/coupons.scss";

const Coupons = () => {
  const [showTerms, setShowTerms] = useState(false);

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="coupons-page color-scheme color-scheme--scheme-1">
      <Header />
      <main className="coupons-page__main">
        <div className="coupons-container">
          <div className="coupons-header">
            <h1 className="coupons-title">My Coupons</h1>
            <button
              type="button"
              className="terms-toggle"
              onClick={() => setShowTerms(!showTerms)}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="18" height="18">
                <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
              </svg>
              Coupon Terms
            </button>
          </div>

          {showTerms && (
            <div className="terms-box">
              <h3>Coupon Usage Rules</h3>
              <ul>
                <li>Coupons cannot be combined with other promotional offers</li>
                <li>Minimum purchase amount must be met to use the coupon</li>
                <li>Each coupon can only be used once per account</li>
                <li>Coupons are non-transferable and have no cash value</li>
                <li>Excluded categories may apply - check individual coupon details</li>
              </ul>
            </div>
          )}



          <div className="coupons-list">
            <div className="coupons-empty">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="64" height="64">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
              </svg>
              <p>No coupons available</p>
            </div>
          </div>


        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Coupons;
